import { atom } from 'jotai';

export const productMenuDisabledAtom = atom(false);
